import flatten from 'flat';
import _ from 'lodash';

export default function(formValues) {
  const flattenedWithDotDelimiter = flatten(formValues);
  // keys whose values are empty arrays or empty objects should not be included in flattened keys
  const excludingEmpty = _.omitBy(
    flattenedWithDotDelimiter,
    (value, key) => _.isObject(value) && _.isEmpty(value) && !(value instanceof File)
  );

  const bracketDelimited = _.mapKeys(excludingEmpty, (value, key) =>
    key
      .split('.')
      .map(piece => `[${piece}]`)
      .join('')
  );
  return bracketDelimited;
}
